import { SVGProps } from "react";

export default function SonicWallet(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={props.width ? props.width : "12"}
      height={props.height ? props.height : "12"}
      viewBox="0 0 309.99 309.99"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
    >
      <path
        fill={props.fill ? props.fill : "#7B7B7B"}
        d="M180.26,185.07l.03-.02s-.03.02-.05.03c.01,0,.02,0,.03,0h0Z"
      />
      <path
        fill={props.fill ? props.fill : "#7B7B7B"}
        d="M180.24,185.08c-46.81,14.06-85.52,34.57-109.77,58.59l-1.07,1.07c6.45,6.1,13.52,11.56,21.16,16.2l1.64-2.01c6.62-8.09,13.72-15.9,21.11-23.26,19.83-19.76,42.51-36.86,66.93-50.59Z"
      />
      <path
        fill={props.fill ? props.fill : "#7B7B7B"}
        d="M185.65,164.24H31.12c1.87,25.07,11.18,48.06,25.79,66.76l.67-.67c15.01-14.81,34.55-28.27,58.12-40,20.66-10.29,44.38-19.12,69.95-26.09Z"
      />
      <path
        fill={props.fill ? props.fill : "#7B7B7B"}
        d="M126.41,61.2c41.89,41.74,94.61,69.34,152.44,79.81-6.97-61.88-59.64-110.01-123.64-110.01-16.9,0-33.01,3.37-47.72,9.45,5.97,7.19,12.35,14.19,18.92,20.76h0Z"
      />
      <path
        fill={props.fill ? props.fill : "#7B7B7B"}
        d="M70.47,66.31c24.25,24.06,62.98,44.54,109.8,58.63-24.44-13.76-47.14-30.85-66.98-50.62-7.37-7.34-14.46-15.15-21.11-23.26l-1.64-2.01c-7.64,4.64-14.71,10.09-21.13,16.19l1.07,1.07h-.01Z"
      />
      <path
        fill={props.fill ? props.fill : "#7B7B7B"}
        d="M126.41,248.78c-6.6,6.57-12.97,13.57-18.92,20.76,14.69,6.08,30.82,9.45,47.72,9.45,64,0,116.67-48.14,123.66-110.04-57.82,10.47-110.54,38.07-152.44,79.81l-.02.02Z"
      />
      <path
        fill={props.fill ? props.fill : "#7B7B7B"}
        d="M115.67,119.62v.02c-23.55-11.73-43.08-25.2-58.09-39.99l-.67-.67c-14.61,18.7-23.92,41.69-25.79,66.76h154.5c-25.56-6.97-49.26-15.8-69.95-26.12Z"
      />
    </svg>
  );
}
